module.exports = __webpack_public_path__ + "static/media/truck-couch.08b9c967.svg";